import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=2a2d8854&scoped=true&"
import script from "./Timeline.vue?vue&type=script&lang=js&"
export * from "./Timeline.vue?vue&type=script&lang=js&"
import style0 from "./Timeline.vue?vue&type=style&index=0&id=2a2d8854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2d8854",
  null
  
)

export default component.exports